var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { createDeviceId, navigateToLoginDone } from '../index';
import { codeAtom, emailAtom, phoneCodeAtom, PUSH, readWriteModalHistoryAtom, Tasks, userAtom } from '../../stores';
import { useAtom, useAtomValue } from 'jotai';
import { getCookie, setCookie } from '../_utils';
import { CodeConfirmationFailedAlert } from '../../models/Html';
import { fetchIsLoggedIn, useFetchIsLoggedIn } from './exports';
import { consoleLogExceptProd, logSignupGtm } from '../../logging';
import { useQueryStringParams } from '../hooks';
var apiUrl = (_a = process.env.REACT_APP_ONLINE_API_URL) !== null && _a !== void 0 ? _a : process.env.NEXT_PUBLIC_ONLINE_API_URL;
var addPlustoString = function (countryCode) {
    if (countryCode && countryCode[0] !== '+') {
        countryCode = '+' + countryCode;
    }
    return countryCode;
};
export var fetchIsSignedUpNumber = function (countryCode, phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.get("".concat(apiUrl, "/v2/users/lms_confirm"), {
                        params: {
                            country_code: addPlustoString(countryCode),
                            phone: phoneNumber,
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_1 = _a.sent();
                console.log(e_1);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
var postPhoneAuth = function (countryCode, phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v2/users/lms_confirm"), {
                        phone: phoneNumber,
                        country_code: addPlustoString(countryCode),
                    })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_2 = _a.sent();
                console.log(e_2);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var usePostPhoneAuth = function (setDeadTime, setShowCountDown, setRequestBtnText) {
    return useMutation({
        mutationFn: function (_a) {
            var countryCode = _a.countryCode, phoneNumber = _a.phoneNumber;
            return postPhoneAuth(addPlustoString(countryCode), phoneNumber);
        },
        onSuccess: function (result) {
            if (result.ok) {
                setDeadTime(new Date(new Date().setMinutes(new Date().getMinutes() + 10)));
                setShowCountDown(true);
                setRequestBtnText('재요청');
            }
        },
    });
};
var postPhoneAuthConfirm = function (countryCode, phoneNumber, code) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.put("".concat(apiUrl, "/v2/users/lms_confirm"), {
                        phone: phoneNumber,
                        country_code: addPlustoString(countryCode),
                        code: code,
                    })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_3 = _a.sent();
                console.log(e_3);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var usePostPhoneAuthConfirm = function (setIsAuthentic, setCode, setDeadTime, setAlertText, setShowCountDown) {
    var _a = useAtom(emailAtom), email = _a[0], setEmail = _a[1];
    var _b = useAtom(userAtom), user = _b[0], setUser = _b[1];
    var _c = useAtom(readWriteModalHistoryAtom), currentTask = _c[0], updateHistory = _c[1];
    return useMutation({
        mutationFn: function (_a) {
            var countryCode = _a.countryCode, phoneNumber = _a.phoneNumber, code = _a.code;
            return postPhoneAuthConfirm(addPlustoString(countryCode), phoneNumber, code);
        },
        onSuccess: function (result) {
            if (result.ok) {
                if (result.context.confirmed) {
                    setIsAuthentic(true);
                    setDeadTime(null);
                    setAlertText(null);
                    setEmail(result.context.result.email);
                    setUser(result.context.result);
                    switch (currentTask) {
                        case Tasks.SIGNUP_EMAIL:
                            break;
                        case Tasks.CHANGE_PHONE_NUMBER_ENTER_AND_AUTH:
                            updateHistory({ action: PUSH, task: Tasks.CHANGE_PHONE_NUMBER_READY });
                            break;
                        default:
                            setTimeout(function () {
                                if (result.context.is_kko) {
                                    updateHistory({ action: PUSH, task: Tasks.LOGIN_KAKAO });
                                }
                                else {
                                    updateHistory({ action: PUSH, task: Tasks.FIND_EMAIL_DONE });
                                }
                            }, 1000);
                            break;
                    }
                }
                else {
                    setAlertText(CodeConfirmationFailedAlert);
                    setShowCountDown(false);
                }
            }
        },
    });
};
var postEmailAuth = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v2/users/email_confirm"), {
                        email: email,
                    })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_4 = _a.sent();
                console.log(e_4);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var useEmailAuth = function (setEmailWarning) {
    var _a = useAtom(readWriteModalHistoryAtom), currentTask = _a[0], updateHistory = _a[1];
    return useMutation({
        mutationFn: function (_a) {
            var email = _a.email;
            return postEmailAuth(email);
        },
        onSuccess: function (result) {
            if (result.ok) {
                if (currentTask === Tasks.CHANGE_EMAIL_ENTER) {
                    if (result.is_unique) {
                        updateHistory({ action: PUSH, task: Tasks.CHANGE_EMAIL_AUTH });
                    }
                    else {
                        setEmailWarning('이메일을 다시 확인해 주세요.');
                    }
                }
                else if (currentTask === Tasks.CHANGE_PASSWORD_INITIAL) {
                    if (!result.is_unique) {
                        updateHistory({ action: PUSH, task: Tasks.CHANGE_PASSWORD_AUTH });
                    }
                    else {
                        setEmailWarning('이메일을 다시 확인해 주세요.');
                    }
                }
                else {
                }
            }
        },
    });
};
var postEmailAuthConfirm = function (email, code) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.put("".concat(apiUrl, "/v2/users/email_confirm"), {
                        email: email,
                        code: code,
                    })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_5 = _a.sent();
                console.log(e_5);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var useEmailAuthConfirm = function (setWarningText, setDeadTime, setShowCountDown) {
    var _a = useAtom(readWriteModalHistoryAtom), currentTask = _a[0], updateHistory = _a[1];
    var email = useAtomValue(emailAtom);
    return useMutation({
        mutationFn: function (_a) {
            var code = _a.code;
            return postEmailAuthConfirm(email, code);
        },
        onSuccess: function (result) {
            if (result.ok) {
                if (result.context.confirmed) {
                    setDeadTime(null);
                    setWarningText('');
                    if (currentTask === Tasks.CHANGE_EMAIL_AUTH) {
                        updateHistory({ action: PUSH, task: Tasks.CHANGE_EMAIL_READY });
                    }
                    else {
                        updateHistory({ action: PUSH, task: Tasks.CHANGE_PASSWORD_ENTER });
                    }
                }
                else {
                    setWarningText(CodeConfirmationFailedAlert);
                    setShowCountDown(false);
                }
            }
        },
    });
};
export var getIsEmailDuplicate = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.get("".concat(apiUrl, "/v1/auth/login_v2?email=").concat(email))];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_6 = _a.sent();
                console.log(e_6);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
var postLoginEmail = function (email, password) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v1/auth/login_v2"), {
                        email: email,
                        password: password,
                        device_id: createDeviceId(),
                        current: window.location.href,
                    }, { withCredentials: true })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_7 = _a.sent();
                console.log(e_7);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var useLoginEmail = function (setIsShow, setEmailWarning, setPasswordWarning, CPLogger, _nextPage) {
    var _a = useState(_nextPage), nextPage = _a[0], setNextPage = _a[1];
    var queryClient = useQueryClient();
    var params = useQueryStringParams();
    useFetchIsLoggedIn();
    useEffect(function () {
        if (params.get('login_v2_next')) {
            setNextPage(params.get('login_v2_next') || '/');
        }
    }, [params.get('login_v2_next')]);
    return useMutation({
        mutationFn: function (_a) {
            var email = _a.email, password = _a.password;
            return postLoginEmail(email, password);
        },
        onSuccess: function (result) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                consoleLogExceptProd(true, 'login result: ', result);
                if (result.ok) {
                    queryClient.setQueryData(['isLoggedIn'], true);
                    navigateToLoginDone(setIsShow, result.user._id, nextPage);
                }
                else {
                    setPasswordWarning(result.message);
                }
                return [2];
            });
        }); },
    });
};
var postSignupEmail = function (name, email, password, phone, countryCode, gender, birthday, marketingAgreement, kkoId, current) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v1/auth/signup"), {
                        name: name,
                        email: email,
                        password: password,
                        phone: phone,
                        country_code: addPlustoString(countryCode),
                        gender: gender,
                        birthyear: birthday.slice(0, 4),
                        birthday: birthday.slice(4, 8),
                        marketing_agreement: marketingAgreement,
                        kko_id: kkoId,
                        method: kkoId ? 'kakao' : 'email',
                        current: current,
                    }, { withCredentials: true })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_8 = _a.sent();
                if (e_8.response.status === 400) {
                    return [2, e_8.response.data];
                }
                else {
                    console.error(e_8);
                    throw e_8;
                }
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var useSignupEmail = function (setIsShow, setIsButtonDisabled, CPLogger, nextPage) {
    var queryClient = useQueryClient();
    useFetchIsLoggedIn();
    return useMutation({
        mutationFn: function (_a) {
            var name = _a.name, email = _a.email, password = _a.password, phone = _a.phone, countryCode = _a.countryCode, gender = _a.gender, birthday = _a.birthday, marketingAgreement = _a.marketingAgreement, kkoId = _a.kkoId, current = _a.current;
            return postSignupEmail(name, email, password, phone, addPlustoString(countryCode), gender, birthday, marketingAgreement, kkoId, current);
        },
        onMutate: function () {
            setIsButtonDisabled(true);
        },
        onSuccess: function (result) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (result.ok) {
                    queryClient.setQueryData(['isLoggedIn'], true);
                    logSignupGtm(result.user, CPLogger);
                    navigateToLoginDone(setIsShow, result.user._id, nextPage, true);
                }
                else {
                    alert(result.message);
                }
                setIsButtonDisabled(false);
                return [2];
            });
        }); },
        onError: function (error) {
            alert(error);
            setIsButtonDisabled(false);
        },
    });
};
var getUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token, token_1, response, e_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getCookie('token');
                if (!token) {
                    return [2, { noToken: true }];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                token_1 = getCookie('token');
                return [4, axios.get("".concat(apiUrl, "/v1/auth/verify"), {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CLIENT-KEY': 'sparta',
                            Authorization: "Bearer ".concat(token_1),
                        },
                    })];
            case 2:
                response = _a.sent();
                return [2, response.data.user];
            case 3:
                e_9 = _a.sent();
                console.log(e_9);
                return [3, 4];
            case 4: return [2];
        }
    });
}); };
export var useUserInfo = function () {
    var _a;
    var query = useQuery({
        queryKey: ['userInfo'],
        queryFn: function () {
            return fetchIsLoggedIn();
        },
        staleTime: 0,
        gcTime: 0,
    });
    var isSuccess = query.isSuccess && !((_a = query.data) === null || _a === void 0 ? void 0 : _a.noToken);
    return __assign(__assign({}, query), { isSuccess: isSuccess });
};
var updateMarketingAgreement = function (userId, marketingAgreement) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v2/users/marketing_agreement"), {
                        _id: userId,
                        marketingAgreement: marketingAgreement,
                    }, {
                        headers: authHeader(),
                        withCredentials: true,
                    })];
            case 1:
                response = _a.sent();
                return [3, 3];
            case 2:
                e_10 = _a.sent();
                if (e_10.response.status === 401) {
                    console.log(e_10);
                }
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var useUpdateMarketingAgreement = function (setWelcomeContents) {
    return useMutation({
        mutationFn: function (_a) {
            var userId = _a.userId, marketingAgreement = _a.marketingAgreement;
            return updateMarketingAgreement(userId, marketingAgreement);
        },
        onSuccess: function (result) {
            setWelcomeContents('couponIssuedNow');
        },
    });
};
var changePassword = function (email, password, code) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v1/accounts/reset"), {
                        email: email,
                        password: password,
                        code: code,
                    }, { headers: authHeader(), withCredentials: true })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_11 = _a.sent();
                if (e_11.response.status === 400) {
                    return [2, e_11.response.data];
                }
                else {
                    console.error(e_11);
                    throw e_11;
                }
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var useChangePassword = function () {
    var _a = useAtom(readWriteModalHistoryAtom), _ = _a[0], updateHistory = _a[1];
    var email = useAtomValue(emailAtom);
    var code = useAtomValue(codeAtom);
    return useMutation({
        mutationFn: function (_a) {
            var password = _a.password;
            return changePassword(email, password, code);
        },
        onSuccess: function (result) {
            if (result.ok)
                updateHistory({ action: PUSH, task: Tasks.CHANGE_PASSWORD_DONE });
            else
                alert(result.message);
        },
        onError: function (error) {
            console.error(error);
        },
    });
};
var changePhoneNumber = function (newPhone, newCountryCode, code) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v1/accounts/reset_phone"), {
                        phone: newPhone,
                        country_code: addPlustoString(newCountryCode),
                        code: code,
                    }, { headers: authHeader(), withCredentials: true })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_12 = _a.sent();
                console.log(e_12);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var useChangePhoneNumber = function () {
    var _a = useAtom(readWriteModalHistoryAtom), _ = _a[0], updateHistory = _a[1];
    var code = useAtom(phoneCodeAtom)[0];
    return useMutation({
        mutationFn: function (_a) {
            var newPhone = _a.newPhone, newCountryCode = _a.newCountryCode;
            return changePhoneNumber(newPhone, newCountryCode, code);
        },
        onSuccess: function (result) {
            if (result.ok) {
                updateHistory({ action: PUSH, task: Tasks.CHANGE_PHONE_NUMBER_DONE });
            }
        },
        onError: function (error) {
            alert(error);
        },
    });
};
var changeEmail = function (newEmail, code) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v1/accounts/reset_email"), {
                        email: newEmail,
                        code: code,
                    }, { headers: authHeader(), withCredentials: true })];
            case 1:
                response = _a.sent();
                return [2, response.data];
            case 2:
                e_13 = _a.sent();
                console.log(e_13);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var useChangeEmail = function () {
    var _a = useAtom(readWriteModalHistoryAtom), _ = _a[0], updateHistory = _a[1];
    var code = useAtom(codeAtom)[0];
    return useMutation({
        mutationFn: function (_a) {
            var newEmail = _a.newEmail;
            return changeEmail(newEmail, code);
        },
        onSuccess: function (result) {
            if (result.ok) {
                updateHistory({ action: PUSH, task: Tasks.CHANGE_EMAIL_DONE });
            }
        },
        onError: function (error) {
            alert(error);
        },
    });
};
export var refreshToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, token, e_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios.post("".concat(apiUrl, "/v1/auth/refresh"), {}, {
                        headers: { Authorization: 'Bearer ' + getCookie('refresh') },
                        withCredentials: true,
                    })];
            case 1:
                response = _a.sent();
                console.log('token refreshed');
                token = response.data.data.token;
                return [2, token];
            case 2:
                e_14 = _a.sent();
                console.log('here logout');
                _logout();
                throw new Error('Token refresh failed');
            case 3: return [2];
        }
    });
}); };
var _logout = function () {
    setCookie('user_id', '', 0);
    setCookie('userinfo', '', 0);
    setCookie('user_info', '', 0);
    setCookie('user_created_at', '', 0);
    setCookie('token', '', 0);
    setCookie('refresh', '', 0);
    setCookie('user_token', '', 0);
    setCookie('birthday', '', 0);
};
export var authHeader = function () {
    return {
        'Content-Type': 'application/json',
        'X-CLIENT-KEY': 'sparta',
        Authorization: "Bearer ".concat(getCookie('token')),
    };
};
//# sourceMappingURL=index.js.map